import React, { forwardRef } from 'react';

import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { Control } from '@vlabs/uikit';
import { useController } from 'react-hook-form';

import { useSearchApi } from '../../../../api/SearchApiProvider';
import { useApiData } from '../../../../api/useApiData';
import st from '../popovers.module.sass';

function ListsFilterPopover(
  {
    name = 'list_id',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const api = useSearchApi();
  const { field } = useController({ name });
  const { data: listsOptions = [] } = useApiData(api.getListOptions);

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {listsOptions.map((option: Option) => {
          return (
            <Control.Radio
              checked={field.value === option.value}
              key={option.value}
              label={option.label}
              onChange={() => field.onChange(option.value)}
            />
          );
        })}
      </div>
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const ListsFilterPopoverWithRef = forwardRef(ListsFilterPopover);
export { ListsFilterPopoverWithRef as ListsFilterPopover };
